"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Clipboard___StyledSvg",
  componentId: "sc-1mcdv7x-0"
})(["color:", ";height:", ";width:", ";font-size:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

function Clipboard(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size,
    _css4: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.444 19H4.556A1.562 1.562 0 013 17.435V6.478c0-.862.698-1.565 1.556-1.565H6.11V3.348H7C7.347 2.003 8.555 1 10 1c1.445 0 2.653 1.003 3 2.348h.889v1.565h1.556c.857 0 1.555.703 1.555 1.565v10.957c0 .863-.698 1.565-1.556 1.565zM6.111 6.478H4.556v10.957h10.889V6.478h-1.556v1.565H6.11V6.478zm.907 8.472h4.473v-1.5H7.018v1.5zm0-3h5.964v-1.5H7.018v1.5zm.649-5.472h4.666V4.913H7.667v1.565zm3.68-3.13A1.553 1.553 0 0010 2.565c-.575 0-1.077.315-1.347.783h2.693z",
    fill: "currentColor"
  }));
}

var _default = Clipboard;
exports["default"] = _default;